import React from 'react';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import List from '@mui/material/List';
import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';

import ChatTextBox from './text-box';
import Alert from 'app/common/alert';
import MessageItem from './message-item';
import Chip from 'app/common/chip';

const MessageList = (props) => {
  const { user, i18n, data: newData, getData, closeThread, openThread, admin } =
    props || {};
  const { agentUnique, id, closed } = newData || {};
  const messages = newData.messages;
  const seeker = newData?.seeker;
  const uuid = agentUnique?.replace('rentals-', '');

  return messages?.length ? (
    <>
      <div style={{ display: 'flex', justifyContent: 'space-between' }}>
        <div style={{ display: 'flex' }}>
          <Typography variant="h6" style={{ marginRight: '15px' }}>
            {i18n('Dwelling') + ': '}
          </Typography>
          <a
            style={{ alignSelf: 'center' }}
            href={`/dwellings/${uuid}/preview`}
          >
            {uuid}
          </a>
        </div>
        {closed ? (
          <Button onClick={openThread}>{i18n('Reopen thread')}</Button>
        ) : (
          <Button onClick={closeThread}>{i18n('Close thread')}</Button>
        )}
      </div>

      <Divider style={{ clear: 'both' }} />
      {newData.recipients.map((recipient) => {
        const isLandlord = recipient.client === 'LANDLORD_DASHBOARD';

        if (isLandlord && !admin) {
          return null;
        }

        return (
          <div
            key={`${recipient.client}-${recipient.email}`}
            style={{ display: 'flex', flexWrap: 'wrap' }}
          >
            <Typography variant="h6" style={{ marginRight: '15px' }}>
              {i18n(isLandlord ? 'Landlord' : 'Seeker') + ': '}
            </Typography>
            <Chip spacing selectable icon="person" label={recipient.name} />
            <Chip spacing selectable icon="email" label={recipient.email} />
          </div>
        );
      })}
      <Divider style={{ clear: 'both' }} />
      <Grid id="chat-window" xs={12} item>
        <List id="chat-window-messages" style={{ overflowY: 'auto' }}>
          {messages.map((item, idx) => (
            <MessageItem
              key={item.id || item._id || idx}
              seekerId={seeker.externalId}
              item={item}
              idx={idx}
              i18n={i18n}
            />
          ))}
        </List>
      </Grid>
      <br />
      <Grid xs={12} item>
        {!admin && !closed ? (
          <ChatTextBox
            variables={{
              userId: user ? user.id : null,
              agentUnique,
              thread: id,
              seekerId: seeker.externalId,
              seekerName: seeker.name,
              seekerEmail: seeker.email
            }}
            i18n={i18n}
            afterClick={() => getData()}
          />
        ) : null}
      </Grid>
    </>
  ) : (
    <Alert type={'info'} text={i18n('No messages')} />
  );
};

export default MessageList;